<template>
  <div class="div">
    <homeMenu ></homeMenu>
    <div class="container">
      <!-- 顶部：统计 + 地图 + 人员状态 -->
      <div class="top">
        <div class="div-column">
          <homeItem class="div-column-item" title="设备提单统计">
            <eCharts v-if="deviceStatsChart.length" :list="deviceStatsChart" :key="'ds-' + panelTick"></eCharts>
            <div v-else class="empty-hint">暂无数据</div>
          </homeItem>
        </div>

        <bdMap class="center" type="robot" :list="mapList"></bdMap>

        <div class="div-column">
          <homeItem class="div-column-item" title="人员接单信息">
            <staffRankTable v-if="staffRankList.length" :table-data="staffRankList"></staffRankTable>
            <div v-else class="empty-hint">暂无数据</div>
          </homeItem>
        </div>
      </div>

      <!-- 底部：TOP + 列表 + 排名 -->
      <div class="bottom">
        <homeItem class="div-bottom" title="设备提单TOP5">
          <progressSelf :list="deviceTopList"></progressSelf>
        </homeItem>
        <workOrderTable
          class="center-bottom"
          :table-data="tableData"
          :loading="listLoading"
          @row-click="openDetail"
          @search="onSearch"
        ></workOrderTable>
        <homeItem class="div-bottom" title="接单排名TOP5">
          <progressSelfRight :list="staffTopList"></progressSelfRight>
        </homeItem>
      </div>
    </div>

    <!-- 工单详情弹窗 -->
    <workOrderDetailDialog
      :visible.sync="detailVisible"
      :detail="detailData"
      :loading="detailLoading"
    ></workOrderDetailDialog>
  </div>
</template>

<script>
import homeMenu from "../components/homeMenu.vue";
import homeItem from "../components/homeItem.vue";
import eCharts from "../components/eCharts.vue";
import progressSelf from "../components/progress.vue";
import progressSelfRight from "../components/progressRight.vue";
import bdMap from "../components/bdMap.vue";
import workOrderTable from "./components/workOrderTable.vue";
import staffRankTable from "./components/staffRankTable.vue";
import workOrderDetailDialog from "./components/workOrderDetailDialog.vue";
import {
  statusLabel,
  urgencyLabel,
  chartColor,
  staffBizLabel,
} from "@/common/js/workOrderDict";

const REFRESH_MS = 30000;

export default {
  name: "aftersaleOverview",
  components: {
    homeMenu,
    homeItem,
    eCharts,
    bdMap,
    progressSelf,
    progressSelfRight,
    workOrderTable,
    staffRankTable,
    workOrderDetailDialog,
  },
  data() {
    return {
      timer: null,
      mapUpdateTimer: null,
      lastMapDataHash: "",
      listLoading: false,
      detailLoading: false,
      detailVisible: false,
      detailData: null,
      keyword: null,
      // 5.4
      deviceStatsChart: [],
      deviceTopList: [],
      // 5.3
      mapList: [],
      // 5.5
      staffRankList: [],
      staffTopList: [],
      // 5.1
      tableData: [],
      panelTick: 0,
    };
  },
  mounted() {
    this.refreshAll();
    this.timer = setInterval(() => {
      this.refreshAll();
    }, REFRESH_MS);
  },
  beforeDestroy() {
    clearInterval(this.timer);
    if (this.mapUpdateTimer) clearTimeout(this.mapUpdateTimer);
  },
  methods: {
    refreshAll() {
      this.panelTick += 1;
      this.fetchStats();
      this.fetchMap();
      this.fetchStaffRank();
      this.fetchList();
    },
    /** 5.4 提单统计 */
    fetchStats() {
      this.$api.workorders
        .stats({
          data: {
            orderBy: "submitOrderNum_desc",
            startTime: null,
            endTime: null,
          },
        })
        .then((res) => {
          const data = res.data || {};
          const list = data.list || [];
          this.deviceStatsChart = list.slice(0, 8).map((item, i) => ({
            value: item.submitOrderNum,
            name: `${item.submitOrderNum}\n${item.deviceName || item.deviceModel || "-"}`,
            itemStyle: { color: chartColor(i) },
          }));
          const max = list[0] ? list[0].submitOrderNum : 1;
          const topList = list.slice(0, 5).map((item, i) => ({
            title: item.deviceName || item.deviceModel || "-",
            progress: i === 0 ? 100 : Math.round((item.submitOrderNum / max) * 100),
            value: item.submitOrderNum,
          }));
          while (topList.length < 5) {
            topList.push({ title: "-", progress: 0, value: 0 });
          }
          this.deviceTopList = topList;
        })
        .catch(() => {
          this.deviceStatsChart = [];
          this.deviceTopList = [];
        });
    },
    /** 5.3 地图分布 */
    fetchMap() {
      this.$api.workorders
        .map({
          data: {
            workOrderStatusList: null,
            statusGroupList: null,
            keyword: null,
          },
        })
        .then((res) => {
          const list = (res.data && res.data.list) || [];
          //console.log(list.length)
          const newMapList = [];
          for (let i = 0; i < list.length; i++) {
            const item = list[i];
            if (
              item.longitude != null &&
              item.latitude != null &&
              item.longitude !== 0 &&
              item.latitude !== 0
            ) {
              newMapList.push({
                id: item.workOrderId || `wo_${i}`,
                position: { lng: item.longitude, lat: item.latitude },
                title: item.workOrderId,
                workOrderStatus: item.workOrderStatus,
                urgencyLevel: item.urgencyLevel,
                show: false,
                info: {
                  name: `工单:${item.workOrderId}`,
                  status: `状态:${statusLabel(item.workOrderStatus)} | ${urgencyLabel(item.urgencyLevel)}`,
                  address: `客户:${item.customerName || "-"} | ${item.address || "-"} | 售后人员:${item.aftersaleName || "未派"}`,
                },
              });
            }
          }
          this.updateMapListDebounced(newMapList);
        })
        .catch(() => {
          this.updateMapListDebounced([]);
        });
    },
    /** 5.5 接单排名 */
    fetchStaffRank() {
      this.$api.workorders
        .staffRank({
          data: {
            orderBy: "receiveTotal_desc",
            startTime: null,
            endTime: null,
          },
        })
        .then((res) => {
          const list = (res.data && res.data.list) || [];
          this.staffRankList = list;
          const max = list[0] ? list[0].receiveTotal || 1 : 1;
          const topList = list.slice(0, 5).map((item, i) => ({
            title: `${item.aftersaleName || "-"}(${staffBizLabel(item.staffBizStatus)})`,
            progress: i === 0 ? 100 : Math.round((item.receiveTotal / max) * 100),
            value: item.receiveTotal,
          }));
          while (topList.length < 5) {
            topList.push({ title: "-", progress: 0, value: 0 });
          }
          this.staffTopList = topList;
        })
        .catch(() => {
          this.staffRankList = [];
          this.staffTopList = [];
        });
    },
    /** 5.1 工单列表 */
    fetchList() {
      this.listLoading = true;
      this.$api.workorders
        .list({
          data: {
            pageNum: 1,
            pageSize: 50,
            keyword: this.keyword,
            workOrderStatusList: null,
            statusGroupList:null,
            urgencyLevel: null,
            aftersaleUserId: null,
            customerId: null,
            startTime: null,
            endTime: null,
          },
        })
        .then((res) => {
          this.tableData = (res.data && res.data.list) || [];
          this.listLoading = false;
        })
        .catch(() => {
          this.tableData = [];
          this.listLoading = false;
        });
    },
    onSearch(keyword) {
      this.keyword = keyword || null;
      this.fetchList();
    },
    /** 5.2 工单详情 */
    openDetail(row) {
      if (!row || !row.workOrderId) return;
      this.detailVisible = true;
      this.detailLoading = true;
      this.detailData = null;
      this.$api.workorders
        .detail({
          data: { workOrderId: row.workOrderId },
        })
        .then((res) => {
          this.detailData = res.data || null;
          this.detailLoading = false;
        })
        .catch(() => {
          this.detailLoading = false;
        });
    },
    generateMapDataHash(mapList) {
      if (!mapList || mapList.length === 0) return "";
      return mapList
        .map((item) => `${item.id || ""}_${item.position.lng}_${item.position.lat}`)
        .sort()
        .join("|");
    },
    updateMapListDebounced(newMapList) {
      const newHash = this.generateMapDataHash(newMapList);
      if (newHash === this.lastMapDataHash) return;
      this.lastMapDataHash = newHash;
      if (this.mapUpdateTimer) clearTimeout(this.mapUpdateTimer);
      this.mapUpdateTimer = setTimeout(() => {
        this.mapList = newMapList;
        this.mapUpdateTimer = null;
      }, 300);
    },
  },
};
</script>

<style scoped lang="scss">
@import "./css/screen-theme.scss";

.div {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  background:
    radial-gradient(ellipse at 50% 0%, rgba(0, 120, 200, 0.22) 0%, transparent 50%),
    radial-gradient(ellipse at 20% 80%, rgba(0, 60, 120, 0.18) 0%, transparent 40%),
    radial-gradient(ellipse at 80% 70%, rgba(0, 80, 140, 0.15) 0%, transparent 40%),
    linear-gradient(180deg, #061428 0%, $screen-bg 45%, #02060f 100%);
  color: $screen-text;

  /* 细网格氛围 */
  &::before {
    content: "";
    position: absolute;
    inset: 0;
    pointer-events: none;
    z-index: 0;
    opacity: 0.22;
    background-image:
      linear-gradient(rgba(0, 229, 255, 0.06) 1px, transparent 1px),
      linear-gradient(90deg, rgba(0, 229, 255, 0.06) 1px, transparent 1px);
    background-size: 48px 48px;
  }
}

.container {
  position: relative;
  z-index: 1;
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 10px 18px 14px;
  box-sizing: border-box;
  min-height: 0;
}

.top {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  height: 50%;
  min-height: 0;
  gap: 14px;
}

.bottom {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  flex: 1;
  min-height: 0;
  margin-top: 12px;
  gap: 14px;
}

.div-column {
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  min-width: 0;
}

.div-column-item {
  flex: 1;
  min-height: 0;
  height: 100%;
}

.center {
  flex: 0 0 60%;
  width: 60%;
  min-width: 60%;
  box-sizing: border-box;
}

.div-bottom {
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.center-bottom {
  flex: 0 0 60%;
  width: 60%;
  min-width: 60%;
  box-sizing: border-box;
}

.empty-hint {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: $screen-text-dim;
  font-size: 14px;
  letter-spacing: 2px;
  text-shadow: 0 0 8px rgba(0, 229, 255, 0.25);
}
</style>
